'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
    'rootFontSize': '10px',
    'fontSizeXSmall': '0.8rem',
    'fontSizeSmaller': '1.1rem',
    'fontSizeSmall': '1.2rem',
    'fontSizeMediumSmall': '1.3rem',
    'fontSizeMedium': '1.4rem',
    'fontSizeLarge': '1.6rem',
    'fontSizeLarger': '1.8rem',
    'fontSizeXLarge': '2rem',
    'fontSizeXxLarge': '3.2rem',
    'maxWidthMobile': '480px',
    'userMenuLayer': '3',
    'defaultBorderThickness': '1px',
    'defaultColor': 'var(--background-dark-base)',
    'taboola-svg-icon': 'taboolaLogo__taboola-svg-icon___HxyJe',
    'logo-svg': 'taboolaLogo__logo-svg___1Ht5H'
};

/**
 * @deprecated
 */

var TaboolaLogo = function (_Component) {
    _inherits(TaboolaLogo, _Component);

    function TaboolaLogo() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TaboolaLogo);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TaboolaLogo.__proto__ || Object.getPrototypeOf(TaboolaLogo)).call.apply(_ref, [this].concat(args))), _this), _this.renderSvg = function () {
            var color = _this.props.color;

            return _react2.default.createElement(
                'svg',
                {
                    className: styles['logo-svg'],
                    viewBox: '0 0 128 34',
                    preserveAspectRatio: 'xMinYMin meet'
                },
                _react2.default.createElement(
                    'g',
                    { fill: color },
                    _react2.default.createElement('path', {
                        d: 'M77.807 5.378c1.589-2.725 4.58-4.597 9.148-4.57C94.169.85 97.399 5.584 97.369 10.89c-.032 5.307-3.316 10.04-10.532 10-4.508-.027-7.46-1.901-9.032-4.598-1.588 2.735-4.58 4.624-9.149 4.598-7.216-.042-10.443-4.815-10.411-10.12C58.276 5.461 61.558.764 68.773.808c4.51.025 7.462 1.883 9.034 4.569zM0 .803h22.9v6.72h-7.4l.003 19.692H7.398L7.394 7.523H0V.803zM36.652 22.94c-.01 1.437.055 3.06.862 4.28l-7.475-.044c-.181-.517-.288-1.292-.247-1.807h-.074c-1.563 1.76-3.824 2.262-6.193 2.248-3.7-.022-6.76-1.807-6.738-5.824.037-6.043 7.14-5.781 10.88-6.458 1-.18 2-.468 2.007-1.684.008-1.29-1.209-1.777-2.393-1.785-2.256-.01-2.709 1.129-2.75 1.938l-6.808-.038c.253-5.379 5.363-6.235 9.916-6.21 9.176.055 9.08 3.85 9.057 7.535l-.044 7.85zm-7.006-4.353c-.89.438-1.892.69-2.89.905-1.63.36-2.485.76-2.49 2.048-.006.886.95 1.776 2.28 1.784 1.665.009 2.966-.978 3.09-2.968l.01-1.77zM37.73.762h7.326l-.054 9.477h.074c1.118-1.615 3.085-2.563 5.268-2.551 6.436.038 8.145 5.501 8.119 9.997-.029 4.79-2.687 10.117-8.125 10.087-3.59-.022-4.691-1.391-5.61-2.613h-.073l-.014 2.057h-6.91V.762zm10.214 12.22c-2.627-.015-3.233 2.45-3.246 4.697-.013 2.284.565 4.758 3.19 4.773 2.629.013 3.235-2.451 3.248-4.737.013-2.246-.565-4.72-3.192-4.733zm20.798-6.868c-2.776-.017-3.162 2.672-3.174 4.697-.011 2.027.342 4.757 3.117 4.773 2.775.016 3.162-2.708 3.174-4.736.012-2.027-.342-4.719-3.117-4.734zm18.181 0c-2.775-.018-3.16 2.671-3.172 4.698-.013 2.027.34 4.755 3.117 4.772 2.773.016 3.16-2.709 3.172-4.736.012-2.026-.343-4.72-3.117-4.735zm11.234 21.102V.81h7.17v26.407h-7.17zm27.575-4.343c-.007 1.436-.087 3.123.721 4.343h-7.364c-.18-.517-.303-1.399-.261-1.912l-.075-.002c-1.564 1.76-3.822 2.263-6.191 2.25-3.702-.024-6.762-1.81-6.738-5.826.036-6.044 7.137-5.78 10.878-6.457 1-.18 2.002-.47 2.008-1.685.009-1.29-1.208-1.777-2.394-1.784-2.257-.012-2.708 1.127-2.747 1.937l-6.812-.038c.254-5.379 5.366-6.235 9.917-6.207 9.175.051 9.08 3.847 9.058 7.531v7.85zm-7.051-4.35c-.89.435-1.891.687-2.89.902-1.633.36-2.483.761-2.492 2.05-.004.884.952 1.774 2.282 1.782 1.667.009 2.967-.977 3.09-2.968l.01-1.767zm-57.69 2.368c5.202 2.314 10.6 3.341 16.481 3.375 6.179.037 10.864-1.125 16.796-3.375l-.036 6.374c-5.308 2.622-11.065 4.036-16.802 4.003-6.252-.037-10.757-1.316-16.478-4.003l.04-6.374z'
                    })
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TaboolaLogo, [{
        key: 'render',
        value: function render() {
            var href = this.props.href;


            return href && href !== '' ? _react2.default.createElement(
                'a',
                { href: href },
                this.renderSvg()
            ) : this.renderSvg();
        }
    }]);

    return TaboolaLogo;
}(_react.Component);

TaboolaLogo.propTypes = {
    /** Make the logo linkable */
    href: _propTypes2.default.string,
    /** Choose the color of the logo */
    color: _propTypes2.default.string
};

TaboolaLogo.defaultProps = {
    color: styles.defaultColor
};

exports.default = TaboolaLogo;